export default [
  { code: 'transmitterId', name: 'transmitter_id', type: 'input' },
  {
    code: 'firmwareVersion',
    name: 'transmitter_version',
    type: 'input',
  },
  {
    code: 'connectedPlugs',
    name: 'connectedPlugs',
    label: 'connected_plugs',
    type: 'number',
    isNumber: true,
    default: {
      comparison: 'GT',
    },
  },
]
